import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import props from '../../redux/props'
import Layout from '../UI/Layout/Layout'
import SmallContainer from '../UI/Container/SmallContainer'
import Form from './Form'

import bg from '../../assets/image/index/hero/bg.jpg'
import bgMobile from '../../assets/image/index/hero/bg_mobile.jpg'
import logo from '../../assets/image/logo.svg'
import callIcon from '../../assets/image/call/call.svg'

const Hero = styled.div`
  background-image: url(${bg});
  background-size: cover;
  background-position: left center;
  @media (max-width: ${({ theme }) => theme.breakpoint.lg}) {
    background-image: url(${bgMobile});
    background-position: center 25%;
  }
`

/**
 * Schnellkontakt — die Landing Page hinter dem QR-Code auf dem Flyer
 * (flyer/2026-09). Sie ist bewusst nirgends verlinkt: weder Navigation noch
 * Footer noch Sitemap führen hierher, und robots.txt schließt den Pfad aus.
 * Ändert sich der Pfad, muss der QR-Code im Flyer neu erzeugt werden.
 */
const QuickContact = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  // Die Seite gehört dem Flyer, nicht der Suche. Das Meta-Tag ergänzt den
  // robots.txt-Eintrag für Crawler, die JavaScript ausführen.
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)

    const previousTitle = document.title
    document.title = `${t.quickContact.metaTitle} – ${t.generic.company.name}`

    return () => {
      document.head.removeChild(meta)
      document.title = previousTitle
    }
  }, [t])

  return (
    <Layout authLevelRequired={false}>
      <Hero className="relative pt-32 pb-16 lg:pt-40 lg:pb-24">
        <div className="absolute inset-0 bg-pureBlack bg-opacity-60"></div>
        <SmallContainer className="relative">
          <div className="flex flex-row items-center gap-3">
            <img src={logo} alt="" className="h-10 bg-white rounded-lg p-1" />
            <div className="font-bold text-lg text-white">{t.generic.company.name}</div>
          </div>
          <div className="font-bold text-2xl lg:text-3xl text-white mt-6">
            {t.quickContact.hero.headline}
          </div>
          <div className="text-lg lg:text-xl font-thin text-white mt-1">
            {t.quickContact.hero.subline}
          </div>
          <div className="text-sm text-white mt-5">{t.quickContact.hero.text}</div>

          <a
            href={`tel:${t.generic.company.phone}`}
            className="flex flex-row items-center gap-3 bg-white rounded-xl px-4 py-3 mt-8 w-fit"
          >
            <img src={callIcon} alt="" className="w-8 aspect-square" />
            <div>
              <div className="text-xs text-gray">{t.quickContact.hero.callLabel}</div>
              <div className="font-bold text-lg leading-5">{t.generic.company.phone}</div>
            </div>
          </a>
        </SmallContainer>
      </Hero>

      <SmallContainer className="mt-12 lg:mt-16">
        <div className="text-center">
          <div className="font-bold text-xl lg:text-2xl">{t.quickContact.form.headline}</div>
          <div className="text-sm text-gray mt-2">{t.quickContact.form.subline}</div>
        </div>
        <div className="mt-8">
          <Form />
        </div>
      </SmallContainer>
    </Layout>
  )
}

export default QuickContact
